import BaseErc721Contract from "./core/BaseErc721Contract";

export default class CollectioWithFreeMintContract extends BaseErc721Contract {
	// We need to add at least one method, this method to make sure that the adapter is not abstract
	todo() {}
}
